var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as CollectionUtils from "@ane/core/lib/utils/CollectionUtils";
import { getLastCompletedTask, getUpcomingTask, getTaskName, getUpcomingTaskInfo, getUpcomingTaskState, getVertical, getMarkets, getResourceFiles, getReferenceFiles } from "./AnalysisStudyBctUtils.js";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { DO_NOT_REDIRECT } from "@ane/core/lib/services/OptInService";
import { Not_Available } from "../../utils/FormatConstants.js";
import { getDateWithTimezone } from "../../utils/FormatUtils.js";
import ___default from "lodash";
import moment from "moment";
import { pathNameToShortName } from "./AnalysisFilterUtils.js";
import { isDataReady } from "@ane/core/lib/services/RestServiceBase";
import { JobProfileType } from "../../models/Task.js";
import { PredefinedTemplates } from "@ane/exp-data/lib/models";
import { AnalysisStatus, AnalysisType } from "@ane/exp-data/lib/models/expapiv2/AnalysisModels";
import { AsyncRequestStatus } from "@ane/core/lib/models";
const defaultZoneName = "moment.defaultZone.name";
function showNotSupportedDialog(showDialog, title, actionName, stepId) {
  const updatedHref = NavigationService.getCustomQueryParams(`/analysis/details?stepId=${stepId}&${DO_NOT_REDIRECT}=1`);
  showDialog({
    title,
    message: `${actionName} is not supported in this new UX yet, please use the <a href=${updatedHref} target="_blank">legacy UX</a>`
  });
}
var AbstractLocation = /* @__PURE__ */ ((AbstractLocation2) => {
  AbstractLocation2[AbstractLocation2["unset"] = 0] = "unset";
  AbstractLocation2[AbstractLocation2["v2StudyAbstractsByStepId"] = 1] = "v2StudyAbstractsByStepId";
  AbstractLocation2[AbstractLocation2["v2StudyEachAbstractByStepAndStudyId"] = 2] = "v2StudyEachAbstractByStepAndStudyId";
  return AbstractLocation2;
})(AbstractLocation || {});
function findV2StudyAbstractFromStore(studyListReducerState, stepId, studyId, loadAbstractFromStudy) {
  var _a;
  if (!studyId || !stepId) {
    return {
      abstractLocation: 0,
      studyAbstractRequest: { data: null, error: "", status: AsyncRequestStatus.NotStarted }
    };
  }
  const v2StudyAbstractsForStepIdRequest = studyListReducerState.v2StudyAbstractsByStepId[stepId];
  let studyAbstract;
  if (isDataReady(v2StudyAbstractsForStepIdRequest)) {
    studyAbstract = ___default.find(v2StudyAbstractsForStepIdRequest.data, (a) => a.StudyId === studyId);
  }
  const v2StudyAbstractForStepAndStudyIdRequest = (_a = studyListReducerState.v2StudyEachAbstractByStepAndStudyId[stepId]) == null ? void 0 : _a[studyId];
  if (!!studyAbstract && !(v2StudyAbstractForStepAndStudyIdRequest == null ? void 0 : v2StudyAbstractForStepAndStudyIdRequest.data) && !loadAbstractFromStudy) {
    return {
      abstractLocation: 1,
      studyAbstractRequest: { data: studyAbstract, error: "", status: AsyncRequestStatus.Completed }
    };
  } else {
    return v2StudyAbstractForStepAndStudyIdRequest ? {
      abstractLocation: 2,
      studyAbstractRequest: v2StudyAbstractForStepAndStudyIdRequest
    } : {
      abstractLocation: 0,
      studyAbstractRequest: { data: null, error: "", status: AsyncRequestStatus.Pending }
    };
  }
}
function getV2StudyAbstractFromStore(state, stepId, studyId, loadAbstractFromStudy) {
  return findV2StudyAbstractFromStore(state.analysisStudyList, stepId, studyId, loadAbstractFromStudy).studyAbstractRequest;
}
function getV2StudyAbstractFromStoreWithStudyList(state, stepId, studyId, loadAbstractFromStudy) {
  return findV2StudyAbstractFromStore(state, stepId, studyId, loadAbstractFromStudy).studyAbstractRequest;
}
function getStudyTitleAndId(title, studyId) {
  return `Study: ${title} (${studyId})`;
}
function getStudyTitle(studyAbstractRequest) {
  return `Study: ${studyAbstractRequest.Description}`;
}
function getStudyTaskStatus(rawStudy) {
  let lastCompletedTask = getLastCompletedTask(rawStudy);
  let upcomingTask = getUpcomingTask(rawStudy, lastCompletedTask);
  return {
    LastCompletedTaskName: getTaskName(rawStudy, lastCompletedTask),
    UpcomingTaskName: getTaskName(rawStudy, upcomingTask),
    UpcomingTaskInfo: getUpcomingTaskInfo(rawStudy, lastCompletedTask),
    UpcomingStateInfo: getUpcomingTaskState(rawStudy, lastCompletedTask),
    ScorecardLink: lastCompletedTask && lastCompletedTask.XCardLink || null
  };
}
function FilterTypeToName(filterType) {
  const map = {
    Trigger: "Triggered",
    Filter: "Filtered",
    TriggerComplement: "UserTrigComp",
    SessionTrigger: "SessTrig"
  };
  return map[filterType] || filterType;
}
function getStudyFromRawStudy(rawStudy) {
  return __spreadProps(__spreadValues({}, rawStudy), {
    Vertical: getVertical(rawStudy),
    Markets: getMarkets(rawStudy),
    ResourceFiles: getResourceFiles(rawStudy),
    ReferenceFiles: getReferenceFiles(rawStudy),
    StudyTaskStatus: getStudyTaskStatus(rawStudy)
  });
}
function isSideStreamAnalysisFilterInTasks(studyAbstract) {
  var _a;
  const tasksWithSideStreamAnalysisFilter = (_a = studyAbstract.AnalysisTaskAbstracts) == null ? void 0 : _a.filter(
    (taskAbstract) => !!taskAbstract.AnalysisConfiguration.SideStreamAnalysisFilter
  );
  return !!tasksWithSideStreamAnalysisFilter && (tasksWithSideStreamAnalysisFilter == null ? void 0 : tasksWithSideStreamAnalysisFilter.length) > 0;
}
function getV2TriggerFilterType(filter, isSideStreamAnalysisFilterInTasks2) {
  if (!(filter == null ? void 0 : filter.operator) && !isSideStreamAnalysisFilterInTasks2) {
    return null;
  }
  if (isSideStreamAnalysisFilterInTasks2) {
    return "Trigger";
  }
  switch (filter == null ? void 0 : filter.operator) {
    case "CustomTriggerOn":
      return "Trigger";
    case "CustomFilterOn":
      return "Filter";
    case "CustomSessionTriggerOn":
      return "SessionTrigger";
    case "CustomTriggerComplementOn":
      return "TriggerComplement";
    default:
      return filter == null ? void 0 : filter.operator;
  }
}
function getV2ScopeResourcesOrReferences(resourcesOrReferences) {
  return !resourcesOrReferences ? ["-"] : ___default.map(resourcesOrReferences, (r) => pathNameToShortName(r));
}
function getV2TriggerFilterNames(studyAbstract) {
  if (!studyAbstract.UserDefinedFilters) {
    return [];
  }
  return ___default.keys(studyAbstract.UserDefinedFilters);
}
function getV2FlightsInfo(studyAbstract) {
  let flights = studyAbstract.Flights;
  let typeAndName;
  if (Array.isArray(flights)) {
    typeAndName = ___default.map(flights, (f) => ({ flightType: f.FlightType, flightName: f.FlightName }));
  } else {
    typeAndName = ___default.map(flights, (flightType, flightName) => ({ flightType, flightName }));
  }
  let byType = ___default.groupBy(typeAndName, "flightType");
  let treatmentFlights = ___default.map(byType["T"], (f) => `${f.flightName} (T)`);
  let controlFlights = ___default.map(byType["C"], (f) => `${f.flightName} (C)`);
  return [...treatmentFlights, ...controlFlights].join(", ");
}
function getV2SideStreamInfo(analysisStudy) {
  const info = analysisStudy.TriggerFilterSidestreamInfo;
  if (info) {
    try {
      return JSON.parse(info);
    } catch (e) {
      return {
        JoinColumnPairs: { Xuid: "" },
        AvailabilityStream: "",
        Location: `${e.toString()} - ${info}`
      };
    }
  }
  return null;
}
const shouldShow = (test, show) => {
  return show === "true" || show === "only" && test() || show === "false" && !test();
};
function hackGetScorecardIdFromScorecardLink(XCardLink) {
  if (XCardLink) {
    const qIndex = XCardLink.indexOf("?");
    if (qIndex !== -1) {
      const qs = XCardLink.toLocaleLowerCase().substr(qIndex + 1).split("&");
      const foundScorecards = ___default.find(qs, (s) => s.indexOf("scorecardids=") !== -1);
      if (foundScorecards) {
        return foundScorecards.substr("scorecardids=".length);
      }
    }
  }
}
function filterBy(studyAbstractsList, studies, filter, showOneOff, showDisabled, showRetroAA) {
  const filteredStudies = ___default.filter(studyAbstractsList, (studyAb) => {
    const foundStudy = studies[studyAb.Id];
    let scorecardIdList = [];
    if (foundStudy) {
      scorecardIdList = CollectionUtils.mapIfDefined(
        foundStudy && foundStudy.TaskSchedule && foundStudy.TaskSchedule.Tasks,
        (t) => {
          if (t.XCardLink) {
            return hackGetScorecardIdFromScorecardLink(t.XCardLink);
          }
        }
      );
    }
    const combine = [studyAb.Id, studyAb.Description, studyAb.CreatedBy, ...scorecardIdList].join(" ").toLowerCase();
    if (!filter || combine.indexOf(filter.toLowerCase()) !== -1) {
      return shouldShow(() => studyAb.IsOneOff, showOneOff) && shouldShow(() => !studyAb.IsActive, showDisabled) && shouldShow(() => studyAb.IsRetrospectiveAnalysis, showRetroAA);
    } else {
      return false;
    }
  });
  return filteredStudies;
}
function V2filterBy(studyAbstractsList, filter, showOneOff, showDisabled, showRetroAA) {
  const filteredStudies = ___default.filter(studyAbstractsList, (studyAb) => {
    var _a;
    let scorecardIdList = CollectionUtils.mapIfDefined(
      studyAb.AnalysisTaskAbstracts,
      (a) => {
        if (a.ScorecardId) {
          return a.ScorecardId.toString();
        }
      }
    );
    const scorecardId = (_a = studyAb.LatestScorecardId) == null ? void 0 : _a.toString();
    if (scorecardId && !scorecardIdList.includes(scorecardId)) {
      scorecardIdList.push(scorecardId);
    }
    const combine = [studyAb.StudyId, studyAb.Description, studyAb.CreatedBy, ...scorecardIdList].join(" ").toLowerCase();
    if (!filter || combine.indexOf(filter.toLowerCase()) !== -1) {
      return shouldShow(() => studyAb.IsOneOff, showOneOff) && shouldShow(() => !studyAb.IsActive, showDisabled) && shouldShow(() => studyAb.IsRetrospectiveAnalysis, showRetroAA);
    } else {
      return false;
    }
  });
  return filteredStudies;
}
function getABStudies(studyAbstractsList) {
  const filteredStudies = ___default.filter(studyAbstractsList, (studyAb) => {
    return studyAb.ExperimentAnalysisType == PredefinedTemplates.AB && studyAb.StudyStatus == AnalysisStatus.Completed;
  });
  return filteredStudies;
}
function getV2TaskNameWithScorecardPurpose(analysisStudy, analysisTask) {
  if (!analysisTask) {
    return [];
  }
  var taskName = getV2TaskName(analysisStudy, analysisTask);
  if (!!analysisTask.ExecutionConfiguration && !!analysisTask.ExecutionConfiguration.ScorecardPurposeUsedForPrioritization && analysisTask.ExecutionConfiguration.ScorecardPurposeUsedForPrioritization !== "Unknown") {
    return [taskName, analysisTask.ExecutionConfiguration.ScorecardPurposeUsedForPrioritization];
  } else {
    return [taskName];
  }
}
function getV2TaskPriority(analysisTask) {
  if (typeof analysisTask.ExecutionConfiguration === "undefined") {
    return Not_Available;
  }
  var adjustedPriority = analysisTask.ExecutionConfiguration.AdjustedCosmosPriority;
  if (adjustedPriority) {
    return adjustedPriority;
  }
  var cosmosPriority = analysisTask.ExecutionConfiguration.CosmosPriority;
  if (cosmosPriority) {
    return cosmosPriority;
  }
  return Not_Available;
}
function getV2VC(analysisTask) {
  if (typeof analysisTask.ExecutionConfiguration === "undefined") {
    return null;
  }
  var vc = analysisTask.ExecutionConfiguration.VC;
  if (vc) {
    return vc;
  }
  return null;
}
function getV2LastCompletedTask(analysisStudy) {
  return analysisStudy.LatestAnalysisTaskAbstract || null;
}
function getV2UpcomingTask(analysisStudy, lastCompletedTask) {
  return analysisStudy.UpComingAnalysisTaskAbstract || null;
}
function getV2TaskName(analysisStudy, analysisTask) {
  var _a;
  if (!analysisTask) {
    return "";
  }
  let start = analysisTask.StartUnit;
  let end = analysisTask.EndUnit;
  let unit = analysisTask.TimeUnit;
  let taskName;
  if (start === null && end === 0 && unit === "Day") {
    taskName = "Partial Day";
  } else if (start === null && unit === "Minute") {
    if ((_a = analysisTask.ComputedAbsoluteAnalysisRange) == null ? void 0 : _a.End) {
      const startDate = getDateWithTimezone(analysisTask.ComputedAbsoluteAnalysisRange.Start, defaultZoneName);
      const endDate = getDateWithTimezone(analysisTask.ComputedAbsoluteAnalysisRange.End, defaultZoneName);
      return `0 - ${moment.duration(endDate.diff(startDate)).asMinutes()} mins`;
    } else {
      if (end && end > 0) {
        taskName = `0 - ${end} mins`;
      } else {
        taskName = "First";
      }
    }
  } else if (start === null && end === null) {
    taskName = analysisStudy.IsRetrospectiveAnalysis ? analysisStudy.ExperimentAnalysisType : "One-Off";
  } else if (start === 0 && end === null) {
    taskName = "Final";
  } else if ((start || start === 0) && end) {
    taskName = `${unit} ${start.toString()}-${end.toString()}`;
  } else {
    taskName = "";
  }
  return taskName;
}
function getV2UpcomingTaskInfo(analysisStudy, lastCompletedTask) {
  if (analysisStudy.IsActive) {
    let upcomingTask = getV2UpcomingTask(analysisStudy, lastCompletedTask);
    if (typeof upcomingTask !== void 0 && upcomingTask !== null) {
      let scorecardName = getV2TaskName(analysisStudy, upcomingTask);
      return "Upcoming: " + scorecardName + " Scorecard";
    } else {
      return "";
    }
  } else {
    return "";
  }
}
function getV2StatusMsg(analysisTask) {
  return "TODO";
}
function getV2UpcomingTaskState(analysisStudy, lastCompletedTask) {
  if (analysisStudy.IsActive) {
    let upcomingTask = getV2UpcomingTask(analysisStudy, lastCompletedTask);
    if (typeof upcomingTask !== "undefined" && upcomingTask !== null) {
      if (false) {
      } else {
        return "Status: " + getV2StatusMsg(upcomingTask);
      }
    } else {
      return "";
    }
  } else {
    return "";
  }
}
function getV2TaskMergeGroupStatus(analysisStudy, analysisTask) {
  var _a;
  if (!analysisTask) {
    return false;
  }
  if (!analysisStudy) {
    return false;
  }
  const findMergeTask = (_a = analysisStudy.AnalysisTaskAbstracts) == null ? void 0 : _a.findIndex(
    (task) => task.StartUnit === analysisTask.StartUnit && task.EndUnit === analysisTask.EndUnit && task.JobProfileType == JobProfileType.Merged
  );
  return findMergeTask !== void 0 && findMergeTask > -1;
}
function getV2JobProfilesSideStreamInfo(analysisStudy) {
  if (isSideStreamAnalysisFilterInTasks(analysisStudy)) {
    const uniqueRegularAbstractsWithSideStream = getUniqueRegularAbstractsWithSideStream(analysisStudy);
    return !!uniqueRegularAbstractsWithSideStream && (uniqueRegularAbstractsWithSideStream == null ? void 0 : uniqueRegularAbstractsWithSideStream.length) > 1 ? uniqueRegularAbstractsWithSideStream.map((abstract) => {
      var _a;
      return {
        sideStreamName: (_a = abstract.AnalysisConfiguration.SideStreamAnalysisFilter) == null ? void 0 : _a.dimension,
        jobProfileDisplayName: abstract.JobProfileName
      };
    }) : null;
  }
  return null;
}
function getV2JobProfilesTriggerExpression(analysisStudy) {
  if (isSideStreamAnalysisFilterInTasks(analysisStudy)) {
    const uniqueRegularAbstractsWithSideStream = getUniqueRegularAbstractsWithSideStream(analysisStudy);
    return !!uniqueRegularAbstractsWithSideStream && (uniqueRegularAbstractsWithSideStream == null ? void 0 : uniqueRegularAbstractsWithSideStream.length) > 1 ? uniqueRegularAbstractsWithSideStream.map((abstract) => {
      var _a;
      return {
        triggerFilterExpression: (_a = abstract.AnalysisConfiguration.SideStreamAnalysisFilter) == null ? void 0 : _a.values[0],
        jobProfileDisplayName: abstract.JobProfileName
      };
    }) : null;
  }
  return null;
}
function getUniqueRegularAbstractsWithSideStream(analysisStudy) {
  var _a, _b;
  const regularAbstractsWithJobProfileNames = (_b = (_a = analysisStudy.AnalysisTaskAbstracts) == null ? void 0 : _a.filter(
    (taskAbstract) => !!taskAbstract.JobProfileName && taskAbstract.JobProfileType !== JobProfileType.Merged
  )) != null ? _b : [];
  const uniqueRegularAbstractsWithSideStream = regularAbstractsWithJobProfileNames == null ? void 0 : regularAbstractsWithJobProfileNames.filter(
    (abstract, currIndex, abstractArray) => abstractArray.findIndex((currentAbstract) => abstract.JobProfileName === currentAbstract.JobProfileName) === currIndex && !!abstract.AnalysisConfiguration.SideStreamAnalysisFilter
  );
  return uniqueRegularAbstractsWithSideStream;
}
function disableCreateAnalysis(experimentInfo, stepId, analysisType) {
  if (!experimentInfo) {
    return false;
  }
  return analysisType === AnalysisType.AB && experimentInfo.Stages.some(
    (stage) => stage.ParallelSteps.some(
      (step) => step.Id === stepId && Object.keys(step.FlightTrafficMap).length <= 1 && step.Type === "DataCollection"
    )
  );
}
export {
  AbstractLocation,
  FilterTypeToName,
  V2filterBy,
  disableCreateAnalysis,
  filterBy,
  findV2StudyAbstractFromStore,
  getABStudies,
  getStudyFromRawStudy,
  getStudyTitle,
  getStudyTitleAndId,
  getUniqueRegularAbstractsWithSideStream,
  getV2FlightsInfo,
  getV2JobProfilesSideStreamInfo,
  getV2JobProfilesTriggerExpression,
  getV2LastCompletedTask,
  getV2ScopeResourcesOrReferences,
  getV2SideStreamInfo,
  getV2StatusMsg,
  getV2StudyAbstractFromStore,
  getV2StudyAbstractFromStoreWithStudyList,
  getV2TaskMergeGroupStatus,
  getV2TaskName,
  getV2TaskNameWithScorecardPurpose,
  getV2TaskPriority,
  getV2TriggerFilterNames,
  getV2TriggerFilterType,
  getV2UpcomingTask,
  getV2UpcomingTaskInfo,
  getV2UpcomingTaskState,
  getV2VC,
  hackGetScorecardIdFromScorecardLink,
  isSideStreamAnalysisFilterInTasks,
  showNotSupportedDialog
};
//# sourceMappingURL=AnalysisStudyUtils.js.map
